import { Controller } from "@hotwired/stimulus"

// Closes a suggestion card without a request and without persisting anything.
// Deliberately not dismissable_card_controller: that one remembers the dismissal in
// sessionStorage, which would also hide the card the next time it is legitimately
// opened for the same record.
export default class extends Controller {
  dismiss(event) {
    event.preventDefault()
    this.element.remove()
  }
}
